import SalesDashboard from './components/SalesDashboard';
export { SalesDashboard };